import { defineStore } from 'pinia'

export const useShippingReportStore = defineStore('shippingReport', {
  state: () => ({
    showtip: true
  }),
  actions: {
    updateShowTip (value) {
      this.showtip = value
    }
  }
})
